/**
 *
 * Asynchronously loads the component for KioskProjectConsumablesPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const KioskProjectConsumablesPage = lazyLoad(
  () => import('./index'),
  module => module.KioskProjectConsumablesPage,
);
